module.exports = __webpack_public_path__ + "static/img/title@2x_app.813bf07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/JuneRecharge/title@2x_app.png
// module id = wTGf
// module chunks = 70